import { createAction } from '@reduxjs/toolkit';

export const goBackToBetslip = createAction('betslip/betReceipt/goBackToBetslip');
